export const getUserToken = () => {
    return JSON.parse(localStorage.token);
} 

export const getAuthorizationHeader = () => {
    return `Bearer ${getUserToken()}`;
}
